// 摄像头评估
import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import { Table, DatePicker } from 'antd'
import columns from './columns'
import moment from 'moment';
import './index.less'
const { WizSpin, WizButton, WizModal, WizCard, WizForm, WizRow, WizCol } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

import CounselingHeader from '../../header'

const findParamRecord = (history) => {
  let record = {}
  if (history.location && history.location.pathname === '/integrationCounseling/manager/track/cameraEvaluation') {
    if (history.location && history.location.record) {
      record = history.location.record
      Session.set('trackCameraEvaluation', record)
    } else {
      record = Session.get('trackCameraEvaluation') || {}
    }
  }
  return record
}

class TrakCameraEvaluation extends WizContainer {

  componentName = 'TrakCameraEvaluation'

  constructor(props) {
    super(props)
    let record = findParamRecord(props.history)
    this.state = {
      record,
      data: [],
      visible: false,
      modalInfo: {}
    }
  }

  _componentDidMount() {
    this.getList()
  }

  getList = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/cameraList',
      payload: {
        key: 'cameraList@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId
        }
      }
    })
  }

  markConfirmed = () => {
    const { processContentId, tutorId } = this.state.record
    this.doAction({
      path: 'counselingProcess/cameraNoticeTargetConfirm',
      payload: {
        key: 'cameraNoticeTargetConfirm@' + processContentId,
        apiParams: {
          fuseTutorId: tutorId,
          tutorContentId: processContentId
        }
      }
    })
  }

  propsAndStateOnChange = {
    list: this._getList.bind(this),
    markConfirmed: this._markConfirmed.bind(this),
    cameraObtainCameraAssess: this._cameraObtainCameraAssess.bind(this),
  }

  _getList(nextProps, nextState) {
    let { list } = nextProps
    let { success, msg, data } = list
    if (success) {
      nextState.data = data
      return true
    }
    wizNotice.error(msg || '获取摄像头评估列表失败')
    return false
  }

  // 获取摄像头评估
  _cameraObtainCameraAssess(nextProps, nextState) {
    let { cameraObtainCameraAssess } = nextProps
    let { success, msg, data } = cameraObtainCameraAssess
    if (success) {
      // nextState.data = data
      this.getList()
      return true
    }
    wizNotice.warning(msg || '获取摄像头评估失败')
    return false
  }

  // 达标确认
  _markConfirmed(nextProps, nextState) {
    let { markConfirmed } = nextProps
    let { success, msg } = markConfirmed
    if (success) {
      wizNotice.success(msg)
      this.jumpPage('goBack')
      return true
    }
    wizNotice.error(msg || '达标确认失败')
    return false
  }

  _onBtn = (type) => {
    switch (type) {
      case 1:
        this.setState({
          visible: true
        })
        break
      case 2:
        WizModal.confirm({
          title: '注意',
          content: '是否确认进行达标确认操作？',
          onOk: () => {
            this.markConfirmed()
          },
          onCancel() {
          }
        })
        break
      default:
        break
    }
  }

  // modal弹出框内容
  _returnModalProps = () => {
    let { visible } = this.state
    return {
      title: '获取摄像头评估(时间选择)',
      visible,
      footer: null,
      width: 700,
      destroyOnClose: true,
      onCancel: () => {
        this.setState({ visible: false })
      },
      afterClose: () => {
        this.setState({ visible: false })
      }
    }
  }

  // 时间选择后的提示,是否触发获取
  _onTimerChoiceCallBack = (values) => {
    let monthly = values['monthly'].format('YYYY-MM')
    WizModal.confirm({
      title: '注意',
      content: `是否确认获取${monthly}摄像头评估数据`,
      onOk: () => {
        this.setState({ visible: false })
        const { tutorId, processContentId } = this.state.record
        this.doAction({
          path: 'counselingProcess/cameraObtainCameraAssess',
          payload: {
            key: 'cameraObtainCameraAssess@' + processContentId,
            apiParams: {
              fuseTutorId: tutorId,
              monthly: monthly
            }
          }
        })
      },
      onCancel: () => {
        this.setState({ visible: false })
      }
    })
  }

  // 设置可选日期
  _disabledDate = (current) => {
    return current && current > moment().endOf('day')
  }

  // 选择需要获取的日期
  _choiceTime = () => {
    let formColumns = [{
      title: '摄像头评估年月',
      formItem: {
        type: 'custom',
        render: (data, form) => {
          const { getFieldDecorator } = form;
          return (
            <div>
              {
                getFieldDecorator('monthly', {
                  rules: [{ required: true, message: '请选择需要拉取的摄像头评估年月', }],
                  initialValue: moment(new Date()).subtract(1, 'months') // 默认上个月
                })(
                  <DatePicker.MonthPicker
                    key='monthly'
                    format='YYYY-MM'
                    disabledDate={this._disabledDate}
                    placeholder={'请选择需要拉取的摄像头评估度年月'}
                  />
                )
              }
            </div>
          )
        }
      }
    }]

    const footer = () => {
      return (
        <div className='form-btn'>
          <WizButton type='primary' style={{ marginRight: 20 }} onClick={() => this.setState({ visible: false })}>
            取消
          </WizButton>
          <WizButton type='primary' htmlType='submit'>
            确认
          </WizButton>
        </div>
      )
    }

    const onSubmit = this._onTimerChoiceCallBack.bind(this)

    let formProps = {
      ref: 'dateForm',
      columns: formColumns,
      onSubmit,
      record: null,
      preview: null,
      footer: footer(),
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 10 }
      }
    }
    return (
      <WizForm {...formProps} />
    )
  }

  // 查看
  _handleRow = (row) => {
    let path = '/integrationCounseling/manager/track/cameraEvaluation/detail'
    let { record } = this.state
    this.jumpPage('push', path, { ...record, rowInfo: row })
  }

  render() {
    let { counselingProcessLoading } = this.props
    let { record, data } = this.state
    let tableProps = {
      columns: columns(this._handleRow),
      dataSource: data,
      pagination: false,
      bordered: true,
      rowKey: (e, i) => i
    }

    return (
      <WizSpin spinning={counselingProcessLoading} >
        <CounselingHeader record={record} />
        <WizCard title='摄像头评估'>
          <div style={{ marginBottom: 20 }}>
            <WizButton
              type='primary'
              style={{ marginRight: 15 }}
              onClick={() => this._onBtn(1)}
            >
              {'获取摄像头评估'}
            </WizButton>
          </div>
          <Table {...tableProps} />
        </WizCard>
        <WizModal  {...this._returnModalProps()}>
          {this._choiceTime()}
        </WizModal>
      </WizSpin>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { counselingProcess } = state
  const { processContentId } = findParamRecord(ownProps.history)
  const list = modelUtils.getModelEntity(counselingProcess, 'cameraList@' + processContentId)
  const markConfirmed = modelUtils.getModelEntity(counselingProcess, 'cameraNoticeTargetConfirm@' + processContentId) // 达标确认
  const cameraObtainCameraAssess = modelUtils.getModelEntity(counselingProcess, 'cameraObtainCameraAssess@' + processContentId) // 获取摄像头评估
  const loading = modelUtils.getLoadingState(state, 'counselingProcess')
  return {
    list,
    markConfirmed,
    cameraObtainCameraAssess,
    ...loading
  }
}

export default connect(mapStateToProps)(TrakCameraEvaluation)
